import React, { useState, useEffect } from 'react'
import PTRestAPI from '../../utils/pt_rest_api' // Adjust the path as necessary
import Button from '../Button' // Adjust the path as necessary
import { useAuth } from '../../utils/platform_auth.jsx'

let isFetching = false

const CategoryPopup = ({ onClose, onSelect, selectedCategories }) => {
  const [categories, setCategories] = useState([])
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(selectedCategories)
  const auth = useAuth()

  useEffect(() => {
    const fetchCategories = async () => {
      if (isFetching) return
      isFetching = true
      try {
        const data = await PTRestAPI.ListCategories(auth, {
          search: { title: search },
        })
        setCategories(data.categories)
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
      isFetching = false
    }

    fetchCategories()
  }, [search, auth])

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
  }

  const handleSelectCategory = (category) => {
    setSelected((prevSelected) => {
      let newSelected = [...prevSelected]

      if (newSelected.find((cat) => cat.categoryID === category.categoryID)) {
        newSelected = newSelected.filter(
          (cat) => cat.categoryID !== category.categoryID,
        )
      } else {
        newSelected.push(category)
      }

      return newSelected
    })
  }

  const handleUse = () => {
    // Convert Set to array of category objects
    onSelect(selected)
    onClose()
  }

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center">
      <div className="bg-paper p-4 rounded shadow-lg max-w-md w-full">
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search categories"
            value={search}
            onChange={handleSearchChange}
            className="text-text bg-canvas outline-none border border-bordered rounded p-2 w-full"
          />
        </div>
        <div className="h-[260px] max-h-[260px] overflow-y-auto mb-4">
          {categories.map((category) => (
            <div
              key={category.categoryID}
              onClick={() => handleSelectCategory(category)}
              className={`text-text bg-canvas p-2 cursor-pointer ${
                selected.find((cat) => cat.categoryID === category.categoryID)
                  ? 'bg-neutral_2 text-white'
                  : 'bg-paper'
              }`}
            >
              {category.title}
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button
            variant="action"
            onClick={handleUse}
            className="w-[100px] bg-primary text-white"
          >
            Apply
          </Button>
          <Button
            variant="action_red"
            onClick={onClose}
            className="w-[100px] bg-gray-500 text-white"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CategoryPopup
